import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getUser } from '../store/slices/authSlice';
import { clearPaymentsError, fetchPlans, fetchProducts } from '../store/slices/paymentsSlice';

const usePayments = () => {
    const dispatch = useDispatch();
    const user = useSelector(getUser);

    useEffect(() => {
        return () => {
            dispatch(clearPaymentsError());
        };
    }, [dispatch]);

    // Plans + products are anon-accessible (GET /payment/plan and
    // /payment/product on backend) and the tarot-limit upsell modal —
    // which renders the live plan price — opens for anon users too.
    // Fetch once on mount regardless of auth, then refetch when the
    // user signs in (in case backend personalizes pricing per user).
    useEffect(() => {
        // Unconditional on user change, not "only if we have nothing yet": prices
        // are per-customer, so a list fetched while signed out is the wrong list
        // once they sign in. The old length guard short-circuited exactly that
        // case and the anonymous prices stuck until a reload (HORO-10557).
        dispatch(fetchPlans());
        dispatch(fetchProducts());
    }, [dispatch, user.id]);
};
export default usePayments;
